import { ActionTree, ActionContext } from "vuex";
import { RootState } from "@/store";

import { State } from "./state";
import { Mutations } from "./mutations";
import { AuthMutationTypes } from "./mutation-types";
import { AuthActionTypes } from "./action-types";
import { company } from "@/store/@types";
import { GeneralActionTypes } from "@/store/modules/general/action-types";

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1]
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, "commit">;

export interface Actions {
  [AuthActionTypes.SET_USER](
    { commit }: AugmentedActionContext,
    payload: Array<any> // Obsolete in here but left as an example
  ): Promise<boolean>;
  [AuthActionTypes.SET_COMPANY](
    { commit }: AugmentedActionContext,
    payload: company // Obsolete in here but left as an example
  ): Promise<boolean>;
  [AuthActionTypes.SET_PARTNER](
    { commit }: AugmentedActionContext,
    payload: company // Obsolete in here but left as an example
  ): Promise<boolean>;
  [AuthActionTypes.SET_SITE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<boolean>;
  [AuthActionTypes.SET_GROUP](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<boolean>;
  [AuthActionTypes.SET_AGMS_GROUP](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<boolean>;
  [AuthActionTypes.SET_AGMS_SITE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<boolean>;
  [AuthActionTypes.SET_AGMS_TEMPLATE](
    { commit }: AugmentedActionContext,
    payload: any // Obsolete in here but left as an example
  ): Promise<boolean>;
}

export const actions: ActionTree<State, RootState> & Actions = {
  async [AuthActionTypes.SET_USER]({ commit }, payload: Array<any>) {
    return new Promise(() => {
      commit(AuthMutationTypes.SET_USER, payload);
    });
  },
  async [AuthActionTypes.SET_COMPANY](
    { commit, rootGetters },
    payload: company
  ) {
    let selectedCompany = payload;
    if (payload) {
      const companies = rootGetters.companies;
      selectedCompany = companies.find(
        (f: any) => payload.companyName === f.value
      );
    }
    return new Promise(() => {
      localStorage.setItem("company", JSON.stringify(payload));
      commit(AuthMutationTypes.SET_COMPANY, payload);
    });
  },
  async [AuthActionTypes.SET_PARTNER](
    { commit, rootGetters },
    payload: any
  ) {
    return new Promise(() => {
      localStorage.setItem("partner", JSON.stringify(payload));
      commit(AuthMutationTypes.SET_PARTNER, payload);
    });
  },
  async [AuthActionTypes.SET_SITE](
    { commit, dispatch, rootGetters },
    payload: any
  ) {
    return new Promise(() => {
      let selectedSite = payload;
      if (payload && !payload.key) {
        const sites = rootGetters.sites;
        selectedSite = sites.find((f: any) => payload.site === f.value);
        if (!selectedSite)
          selectedSite = { mainId: payload.mainid, value: payload.site };
      }

      localStorage.setItem("site", JSON.stringify(payload));
      commit(AuthMutationTypes.SET_SITE, selectedSite);
      dispatch(AuthActionTypes.SET_AGMS_SITE, {
        mainid: selectedSite?.mainId || selectedSite?.mainid,
        site: selectedSite?.value,
      });
      dispatch(GeneralActionTypes.SET_COMPKEY, rootGetters.compKey + 1);
    });
  },
  async [AuthActionTypes.SET_GROUP](
    { commit, dispatch, rootGetters },
    payload: any
  ) {
    return new Promise(() => {
      let selectedGroup = payload;
      if (!payload.key) {
        const groups = rootGetters.groups;
        selectedGroup = groups.find((f: any) => payload.group === f.value);
        if (!selectedGroup)
          selectedGroup = {
            mainId: payload.mainid,
            value: payload.group,
            mainid: payload.mainid,
            siteId: payload.siteId,
          };
      }

      localStorage.setItem("group", JSON.stringify(selectedGroup));
      commit(AuthMutationTypes.SET_GROUP, selectedGroup);
      let groupData: any = {
        mainid: selectedGroup.mainId || selectedGroup.mainid,
        group: selectedGroup.value,
        siteId: selectedGroup.siteId,
      }
      if(!selectedGroup.mainId && !selectedGroup.value) {
        groupData = {}
      }
      dispatch(AuthActionTypes.SET_AGMS_GROUP, groupData);
      dispatch(GeneralActionTypes.SET_COMPKEY, rootGetters.compKey + 1);
    });
  },

  async [AuthActionTypes.SET_AGMS_SITE]({ commit }, payload: any) {
    return new Promise(() => {
      localStorage.setItem("agms_site", JSON.stringify(payload));
      commit(AuthMutationTypes.SET_AGMS_SITE, payload);
    });
  },

  async [AuthActionTypes.SET_AGMS_GROUP]({ commit }, payload: any) {
    return new Promise(() => {
      localStorage.setItem("agms_group", JSON.stringify(payload));
      commit(AuthMutationTypes.SET_AGMS_GROUP, payload);
    });
  },

  async [AuthActionTypes.SET_AGMS_TEMPLATE]({ commit }, payload: any) {
    return new Promise(() => {
      localStorage.setItem("agms_template", JSON.stringify(payload));
      commit(AuthMutationTypes.SET_AGMS_TEMPLATE, payload);
    });
  },
};
